export default "__VITE_ASSET__gQDCFHtD__"